import { selectFromRouteTimelineDto } from '../../models';

export default selectFromRouteTimelineDto()
  .id
  .routeSolutionId
  .sequence
  .stopSequence
  .eventUuid
  .orderUuid
  .reattemptEventUuid
  .startTime
  // Drives VisitDtoModel.canBeModified: the orders list has no route timeline to fall back on.
  .isArrived
  .toString();
